import type { PlantEquipment } from '@axilon-apps/domains-ontology-ui-state'

const SPEC_FIELDS: Array<[string, keyof PlantEquipment | string]> = [
  ['Vendor', 'vendor'],
  ['Type', 'equipment_type'],
  ['Area', 'area_name'],
  ['Hierarchical name', 'hierarchical_name']
]

const SPEC_FIELDS_FROM_PROPERTIES: Array<[string, string]> = [
  ['Description', 'description'],
  ['I/O type', 'io_type'],
  ['P&ID number', 'pid_number'],
  ['Datasheet number', 'datasheet_no'],
  ['Model', 'model'],
  ['MCT', 'mct'],
  ['Trace heating', 'trace_heating'],
  ['Winterisation', 'winterisation'],
  ['Capacity', 'capacity'],
  ['Power', 'power'],
  ['Material', 'material'],
  ['Size', 'size'],
  ['Tag number', 'tag_number'],
  ['Range', 'range_low']
]

export function collectEquipmentSpecs(equipment: PlantEquipment): Array<[string, string]> {
  const out: Array<[string, string]> = []
  for (const [label, field] of SPEC_FIELDS) {
    const value = (equipment as unknown as Record<string, unknown>)[field as string]
    if (typeof value === 'string' && value.length > 0) out.push([label, value])
  }
  const props = equipment.properties ?? {}
  for (const [label, field] of SPEC_FIELDS_FROM_PROPERTIES) {
    if (label === 'Range') {
      const low = props['range_low']
      const high = props['range_high']
      if (typeof low === 'number' || typeof high === 'number') {
        const unit = typeof props['unit'] === 'string' ? ` ${props['unit'] as string}` : ''
        out.push([label, `${low ?? '—'} – ${high ?? '—'}${unit}`])
      }
      continue
    }
    const value = props[field]
    if (value === null || value === undefined || value === '') continue
    if (typeof value === 'object') continue
    const unit = typeof props['unit'] === 'string' ? ` ${props['unit'] as string}` : ''
    if (label === 'Capacity' || label === 'Power') {
      out.push([label, `${value as string | number}${unit}`])
    } else {
      out.push([label, String(value)])
    }
  }
  return out
}
